import { db } from "../firebase/config";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { withdrawalsCollection } from "../firebase/firestore";
import { entryFromWithdrawal } from "./financeService";

const toMs = (v) => (v && typeof v.toMillis === "function" ? v.toMillis() : v);

/** All withdrawal requests, newest first, with the raw payout details kept alongside. */
export async function loadWithdrawals() {
  const snap = await getDocs(collection(db, withdrawalsCollection));
  return snap.docs
    .map((d) => {
      const raw = { id: d.id, ...d.data() };
      ["requestedAt", "createdAt", "date", "processedAt", "paidAt"].forEach((k) => {
        if (raw[k] != null) raw[k] = toMs(raw[k]);
      });
      const e = entryFromWithdrawal(raw);
      return {
        ...e,
        status: e.status === "paid" ? "approved" : e.status,
        upiId: raw.upiId || raw.upi || "",
        bankAccount: raw.bankAccount || raw.accountNumber || "",
        bankName: raw.bankName || "",
        ifsc: raw.ifsc || raw.ifscCode || "",
      };
    })
    .sort((a, b) => (b.date || 0) - (a.date || 0));
}

export async function approveWithdrawal(id) {
  await updateDoc(doc(db, withdrawalsCollection, id), { status: "approved", processedAt: Date.now() });
}

export async function rejectWithdrawal(id, reason) {
  await updateDoc(doc(db, withdrawalsCollection, id), {
    status: "rejected",
    rejectionReason: reason || "",
    processedAt: Date.now(),
  });
}
